import Typography, { TypographyProps as Props, Variants } from './Typography';

export type TypographyProps<V extends keyof Variants, P> = Props<V, P>;

export default Typography;
